<template>
  <component
    :is="tag"
    class="min-h-screen px-8 flex flex-col items-center justify-center"
  >
    <div
      class="flex flex-grow justify-center items-center w-full max-w-3xl pb-12 pt-24"
    >
      <slot />
    </div>
    <div
      class="flex justify-center items-center flex-shrink-0 pt-12 pb-24 md:pt-0"
    >
      <slot name="footer" />
    </div>
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
});
</script>
